const actions = {

    AUDIT_READ_REQUEST: 'AUDIT_READ_REQUEST',
    AUDIT_READ_SUCCESS: 'AUDIT_READ_SUCCESS',
    AUDIT_READ_ERROR: 'AUDIT_READ_ERROR',

    AUDIT_READ_ALL_REQUEST: 'AUDIT_READ_ALL_REQUEST',
    AUDIT_READ_ALL_SUCCESS: 'AUDIT_READ_ALL_SUCCESS',
    AUDIT_READ_ALL_ERROR: 'AUDIT_READ_ALL_ERROR',

    AUDIT_RESET_AUDIT: 'AUDIT_RESET_AUDIT',

    // LOCATION_READ_ALL_REQUEST: 'LOCATION_READ_ALL_REQUEST',
    // LOCATION_READ_ALL_SUCCESS: 'LOCATION_READ_ALL_SUCCESS',
    // LOCATION_READ_ALL_ERROR: 'LOCATION_READ_ALL_ERROR',

    // LOCATION_UPDATE_REQUEST: 'LOCATION_UPDATE_REQUEST',
    // LOCATION_UPDATE_SUCCESS: 'LOCATION_UPDATE_SUCCESS',
    // LOCATION_UPDATE_ERROR: 'LOCATION_UPDATE_ERROR',

    // LOCATION_ARCHIVE_REQUEST: 'LOCATION_ARCHIVE_REQUEST',
    // LOCATION_ARCHIVE_SUCCESS: 'LOCATION_ARCHIVE_SUCCESS',
    // LOCATION_ARCHIVE_ERROR: 'LOCATION_ARCHIVE_ERROR',

    // LOCATION_DELETE_REQUEST: 'LOCATION_DELETE_REQUEST',
    // LOCATION_DELETE_SUCCESS: 'LOCATION_DELETE_SUCCESS',
    // LOCATION_DELETE_ERROR: 'LOCATION_DELETE_ERROR',

    AUDIT_RESET_STATE: 'AUDIT_RESET_STATE',

    readAudit: id => ({
        type: actions.AUDIT_READ_REQUEST,
        id,
    }),
    readAllAudit: request => ({
        type: actions.AUDIT_READ_ALL_REQUEST,
        request,
    }),
    resetAudit: () => ({
        type: actions.AUDIT_RESET_AUDIT,
    }),
    // updateLocation: (id, request) => ({
    //   type: actions.LOCATION_UPDATE_REQUEST,
    //   id,
    //   request,
    // }),
    // archiveLocation: (id, request) => ({
    //   type: actions.LOCATION_ARCHIVE_REQUEST,
    //   id,
    //   request,
    // }),
    // deleteLocation: (id) => ({
    //   type: actions.LOCATION_DELETE_REQUEST,
    //   id,
    // }),
    resetLocation: id => ({
        type: actions.AUDIT_RESET_STATE,
        id,
    }),
};
export default actions;
